import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import { getQueryStringValue } from "./Shared/queryString";
import { getTranslations } from "./Shared/Translations/TranslationsService";
import "./index.css";
import App from "./App";

const usersLocale = getQueryStringValue("language") || "en";
const translationsForUsersLocale = getTranslations(usersLocale);

ReactDOM.render(
  //react-intl@v3's TypeScript definitions do not allow children on IntlProvider properly, even though it works at runtime. This mismatch causes TS errors.
  //The impact of upgrading this package is too significant and undesired for now.
  // @ts-ignore
  <IntlProvider locale={usersLocale} messages={translationsForUsersLocale}>
    <App />
  </IntlProvider>,
  document.getElementById("root")
);
